<template>
  <div class="order_confirm wrapper_1200" v-loading="loading">
    <div class="header">
      <router-link class="home" to="/">{{ $t(`userDrawer.data[0].name`) }} </router-link> <span> >
        {{ $t(`page.users.orderConfirm.navTitle`) }} </span>
    </div>
    <!--地址信息表单-->
    <div class="address">
      <div class="title">{{ delivery ==  2 ? $t(`page.orderDetails.address`) : $t('page.orderDetails.selfStore') }}</div>
      <div class="lines">
        <img src="../../assets/images/line.png">
      </div>
      
      <div class="address-form" v-if="delivery ==  2">
        <el-form :model="addressForm" :rules="addressRules" ref="addressForm" label-position="top">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formName')" prop="name">
                <el-input v-model="addressForm.name" :placeholder="$t('page.orderDetails.placeholderName')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formEmail')" prop="email">
                <div style="display: flex; gap: 10px;">
                  <el-input v-model="addressForm.email" :placeholder="$t('page.orderDetails.placeholderEmail')" style="flex: 1;"></el-input>
                  <!-- <el-button 
                    type="primary" 
                    @click="sendVerificationCode" 
                    :disabled="countdown > 0"
                    style="width: 120px;"
                  >
                    {{ countdown > 0 ? `${countdown}${$t('page.orderDetails.sendingCode')}` : $t('page.orderDetails.sendCode') }}
                  </el-button> -->
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <!-- <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formEmailCode')" prop="verificationCode">
                <el-input v-model="addressForm.verificationCode" :placeholder="$t('page.orderDetails.placeholderEmailCode')"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formPhone')" prop="phone">
                <el-input v-model="addressForm.phone" :placeholder="$t('page.orderDetails.placeholderPhone')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formPostCode')" prop="postCode">
                <el-input v-model="addressForm.postCode" :placeholder="$t('page.orderDetails.placeholderPostCode')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            
            <el-col :span="12">
              <el-form-item :label="$t('page.orderDetails.formRegion')" prop="country">
                <el-cascader
                  ref="regionCascader"
                  v-model="selectedRegion"
                  :options="regionOptions"
                  :props="cascaderProps"
                  @change="handleRegionChange"
                  :placeholder="$t('page.orderDetails.placeholderRegion')"
                  style="width: 100%;"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('page.orderDetails.formAddress')" prop="address">
                <el-input 
                  type="textarea" 
                  v-model="addressForm.address" 
                  :placeholder="$t('page.orderDetails.placeholderAddress')"
                  :rows="3"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-checkbox v-model="createAccount">
                {{ $t('page.orderDetails.formCreateAccount') }}
              </el-checkbox>
            </el-col>
          </el-row>
          
          <!-- <el-row>
            <el-col :span="24" style="text-align: right; margin-top: 20px;">
              <el-button type="primary" @click="submitAddress">{{ $t('page.goodsDetail.submit') }}</el-button>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <!-- 门店 -->
      <div class="store-list acea-row row-middle" v-if="delivery == 1">
        <div class="item" :class="current === index ? 'on' : ''" v-for="(item, index) in storeList" :key="index"
          @click="tapCurrent(index, item)">
          <!-- <div class="default bg-color" v-if="item.isDefault">{{ $t(`page.goodsList.default`) }}</div> -->
          <div class="name line1">{{ item.contact }}</div>
          <div class="phone">{{item.name}}{{ item.phone }}</div>
          <div>{{ item.email }}</div>
          <div class="details line4">{{ item.regions + item.address }}</div>
          <div class="iconfont icon-xuanzhong4 font-color" v-if="current === index"></div>
        </div>
        <!-- <div class="item add" @click="addAddress">
          <div class="iconfont icon-tianjia"></div>
          <div class="tip">{{ $t(`page.users.userAddressList.add`) }}</div>
        </div> -->
      </div>
      <!-- 交付方式 -->
      <div class="delivery">
        <div class="title">{{ $t(`page.orderDetails.delivery`) }}</div>
        <div>
          <el-radio v-model="delivery" label="2">{{ $t(`page.orderDetails.deliveryOne`) }}</el-radio>
          <el-radio v-model="delivery" label="1">{{ $t(`page.orderDetails.deliveryTwo`) }}</el-radio>
        </div>
      </div>
    </div>
    <!-- 收货人信息 -->
    <div class="consigneeInfo" v-if="delivery ==  1">
      <div class="title">{{ $t(`page.orderDetails.consigneeInfo`) }}</div>
      <el-form :model="consigneeInfo" :rules="consigneeRules" ref="consigneeForm" label-position="top">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('page.orderDetails.formName')" prop="name">
              <el-input v-model="consigneeInfo.name" :placeholder="$t('page.orderDetails.placeholderName')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('page.orderDetails.formEmail')" prop="email">
              <div style="display: flex; gap: 10px;">
                <el-input v-model="consigneeInfo.email" :placeholder="$t('page.orderDetails.placeholderEmail')" style="flex: 1;"></el-input>
                <!-- <el-button 
                  type="primary" 
                  @click="sendConsigneeVerificationCode" 
                  :disabled="consigneeCountdown > 0"
                  style="width: 120px;"
                >
                  {{ consigneeCountdown > 0 ? `${consigneeCountdown}${$t('page.orderDetails.sendingCode')}` : $t('page.orderDetails.sendCode') }}
                </el-button> -->
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item :label="$t('page.orderDetails.formEmailCode')" prop="verificationCode">
              <el-input v-model="consigneeInfo.verificationCode" :placeholder="$t('page.orderDetails.placeholderEmailCode')"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item :label="$t('page.orderDetails.formPhone')" prop="phone">
              <el-input v-model="consigneeInfo.phone" :placeholder="$t('page.orderDetails.placeholderPhone')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-checkbox v-model="consigneeCreateAccount">
              {{ $t('page.orderDetails.formCreateAccount') }}
            </el-checkbox>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--商品信息-->
    <div class="wrapper wrapper_1200">

      <div v-for="(item, index) in cartInfo" :key="index">
        <order-goods :cartInfo="item.orderInfoList" :orderInfo="item"></order-goods>
      </div>
      <div class="wrapper_count">
        <!--优惠券选择-->
        <div v-show="couponList.length > 0" class="couponListBox">
          <div class='integral_count acea-row row-between'>
            <div class="integral_title">{{ $t(`page.users.orderConfirm.CouponDeduction`) }}：</div>
            <div class="couponPrice font-color">-{{ GLOBAL.shopPayCurrency }}{{ orderInfoVo.couponFee }}</div>
          </div>
          <div class="couponList acea-row row-middle">
            <div class="item acea-row row-middle" :class="itemn.disabled ? 'disabled' : ''"
              v-for="(itemn, indexn) in couponList" :key="indexn" @click="getCoupon(itemn, indexn)">

              <div class="name" v-if="itemn.useType === 1">{{ $t(`page.users.userCoupon.navList[0].name`) }}</div>
              <div class="name" v-else>{{ $t(`page.users.userCoupon.navList[1].name`) }}</div>
              <div class="money line1">{{ itemn.minPrice }} {{ $t(`page.users.userCoupon.minus`) }} {{
                parseFloat(itemn.money) }}</div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="couponIndex === indexn && couponId"></div>
            </div>
          </div>
          <div class="line"></div>
        </div>
        <!--支付选择-->
        <div class="payType">
          <div class="title">{{ $t(`page.orderPayStatus.payType`) }}</div>
          <div class="type acea-row row-middle mb30">
            <!-- <div class="item acea-row row-center-wrapper mr20"
              :class="payStatus === 0 ? 'on' : ''" @click="currentPay(0)">
              <div class="iconfont icon-yue"><img src="@/assets/images/stripe.png" /></div>
              <div>
                <div class="name">Stripe</div>
              </div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="payStatus === 0"></div>
            </div> -->
            <div class="item acea-row row-center-wrapper"
              :class="payStatus === 1 ? 'on' : ''" @click="currentPay(1)">
              <div class="iconfont icon-weixinzhifu1"><img src="../../assets/images/PayPal.png" /></div>
              <div>
                <div class="name">PayPal</div>
              </div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="payStatus === 1"></div>
            </div>
            <div class="item acea-row row-center-wrapper"
              :class="payStatus === 2 ? 'on' : ''" @click="currentPay(2)">
              <div class="iconfont icon-weixinzhifu1"><img class="img" src="../../assets/images/mercado.png" /></div>
              <div>
                <div class="name">Mercado Pago</div>
              </div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="payStatus === 2"></div>
            </div>
            <div class="item acea-row row-center-wrapper"
              :class="payStatus === 3 ? 'on' : ''" @click="currentPay(3)">
              <div class="iconfont icon-weixinzhifu1"><img class="img" src="../../assets/images/offline.png" /></div>
              <div>
                <div class="name">Offline payment</div>
              </div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="payStatus === 3"></div>
            </div>
            <!-- <div class="item acea-row row-center-wrapper"
              :class="payStatus === 2 ? 'on' : ''" @click="currentPay(2)">
              <div class="iconfont icon-weixinzhifu1"><img class="img" src="../../assets/images/wechat.png" /></div>
              <div>
                <div class="name">Wechat</div>
              </div>
              <div class="iconfont icon-xuanzhong4 font-color" v-if="payStatus === 2"></div>
            </div> -->
          </div>
          <div class="line"></div>
        </div>
        <div class="coupon message acea-row">
          <div class="msgTitle">{{ $t(`page.users.orderConfirm.note`) }}</div>
          <textarea class="textarea" :placeholder='$t(`page.users.orderConfirm.placeNote`)' v-model="mark"
            maxlength="150"></textarea>
        </div>
        <div class="totalCon">
          <div class="total acea-row row-middle row-right">
            <div>{{ $t(`page.users.orderConfirm.allPrice`) }}：</div>
            <div class="money">{{ GLOBAL.shopPayCurrency }}{{ orderInfoVo.totalPrice || 0 }}</div>
          </div>
          <div class="total acea-row row-middle row-right"
            v-if="orderInfoVo.couponFee && parseFloat(orderInfoVo.couponFee) > 0">
            <div>{{ $t(`page.users.orderConfirm.CouponDeduction`) }}：</div>
            <div class="money">-{{ GLOBAL.shopPayCurrency }}{{ orderInfoVo.couponFee }}</div>
          </div>
          <div class="total acea-row row-middle row-right">
            <div>{{ $t(`page.users.orderConfirm.freight`) }}：</div>
            <div class="money">+{{ GLOBAL.shopPayCurrency }}{{ orderInfoVo.shippingFree }}</div>
          </div>
        </div>
        <div class="totalAmount">{{ $t(`page.users.orderConfirm.total`) }}：<span class="money font-color">{{
          GLOBAL.shopPayCurrency }}{{ orderInfoVo.payFee || 0 }}</span></div>
        <div class="bnt acea-row row-right">
          <button class="submit" :loading="loading" @click="SubOrder($event)">{{ $t(`page.users.orderConfirm.payPal`)
            }}</button>
        </div>
      </div>
    </div>
    <!-- 右侧浮标 -->
    <FloatWindow></FloatWindow>
    <!-- 微信支付弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisibleQrcode" width="380px"
      :title="$t(`page.users.orderConfirm.payment`)" center :show-close="false" :before-close="handleCloseQrcode">
      <div v-loading="loadingQrcode" class="payQrcode">
        <div id="payQrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleCloseQrcode">{{ $t(`page.users.orderConfirm.paymentResultsNo`)
          }}</el-button>
        <el-button size="small" type="primary" @click="getPaymentStatus">{{ $t(`page.users.orderConfirm.paymentResults`)
          }}</el-button>
      </span>
    </el-dialog>
    <!-- 线下支付弹窗 -->
    <offline-pay :visible.sync="offlinePayDialogVisible" @confirm="handleOfflinePayConfirm"></offline-pay>
  </div>
</template>

<script>
import { Message, MessageBox } from 'element-ui';
import orderGoods from "@/components/orderGoods";
import offlinePay from "@/components/offlinePay";
import { Debounce } from '@/utils/validate.js'
import QRcode from 'qrcodejs2';
import Cookies from 'js-cookie';

export default {
  name: "order_confirmNoLogin",
  auth: "guest",
  components: { orderGoods, offlinePay },
  data() {
    return {
      news: 1,
      loading: false,
      // 地址表单
      addressForm: {
        name: '',
        email: '',
        verificationCode: '',
        phone: '',
        postCode: '',
        country: 'China',
        address: ''
      },
      countdown: 0, // 验证码倒计时
      timer: null, // 倒计时定时器
      // 表单验证规则
      addressRules: {
        name: [
          { required: true, message: this.$t('page.orderDetails.validateName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('page.orderDetails.validateEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('page.orderDetails.validateEmailFormat'), trigger: 'blur' }
        ],
        // verificationCode: [
        //   { required: true, message: this.$t('page.orderDetails.validateEmailCode'), trigger: 'blur' }
        // ],
        phone: [
          { required: true, message: this.$t('page.orderDetails.validatePhone'), trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: this.$t('page.orderDetails.validatePhoneFormat'), trigger: 'blur' }
        ],
        postCode: [
          { required: true, message: this.$t('page.orderDetails.validatePostCode'), trigger: 'blur' },
          // { pattern: /^\d{6}$/, message: this.$t('page.orderDetails.validatePostCodeFormat'), trigger: 'blur' }
        ],
        country: [
          { required: true, message: this.$t('page.orderDetails.validateRegion'), trigger: 'change' }
        ],
        address: [
          { required: true, message: this.$t('page.orderDetails.validateAddress'), trigger: 'blur' },
          { min: 5, message: this.$t('page.orderDetails.validateAddressLength'), trigger: 'blur' }
        ]
      },
      createAccount: false,
      delivery: '2', // 1自提，2快递
      selectedStore: '',
      storeList: [], // 门店列表
      current: undefined,
      checkedStore: {},
      // 收货人信息
      consigneeInfo: {
        name: '',
        email: '',
        verificationCode: '',
        phone: ''
      },
      consigneeCountdown: 0, // 收货人验证码倒计时
      consigneeTimer: null, // 收货人倒计时定时器
      consigneeCreateAccount: false, // 收货人创建账号选项
      // 收货人表单验证规则
      consigneeRules: {
        name: [
          { required: true, message: this.$t('page.orderDetails.validateName'), trigger: 'blur' }
        ],
        email: [
          { required: true, message: this.$t('page.orderDetails.validateEmail'), trigger: 'blur' },
          { type: 'email', message: this.$t('page.orderDetails.validateEmailFormat'), trigger: 'blur' }
        ],
        // verificationCode: [
        //   { required: true, message: this.$t('page.orderDetails.validateEmailCode'), trigger: 'blur' }
        // ],
        phone: [
          { required: true, message: this.$t('page.orderDetails.validatePhone'), trigger: 'blur' },
          // { pattern: /^1[3-9]\d{9}$/, message: this.$t('page.orderDetails.validatePhoneFormat'), trigger: 'blur' }
        ]
      },
      // 地区三级联动
      selectedRegion: [],
      regionOptions: [],
      cascaderProps: {
        lazy: true,
        lazyLoad: this.lazyLoadRegion,
        value: 'id',
        label: 'name',
        children: 'children'
      },
      payStatus: 1, // 0stripe支付，1PayPal支付，2微信支付
      mark: '',//备注信息
      couponIndex: 0, //选择商铺优惠券索引
      couponList: [],
      orderInfoVo: {},
      payType: 'paypal',
      cartInfo: {},
      couponId: null,
      dialogVisibleQrcode: false, //微信支付弹窗
      loadingQrcode: false, //微信支付弹窗加载
      sub_id: '', // 子商品ID
      offlinePayDialogVisible: false, // 线下支付弹窗
      payInfo: {},
      orderNo: '', //支付订单号
      cartId: '',
      weight: 0, // 商品总重量
      mianfree: 0 // 免运费门槛
    }
  },
  // async asyncData({ app, query }) {
  //   let pay = await app.$axios.get('/api/front/pay/method');
  //   return {
  //     cartId: query.cartId,
  //     payInfo: pay.data
  //   }
  // },
  mounted() {
    // 检查是否已登录，如果已登录则跳转到首页
    const token = localStorage.getItem('token');
    const userInfo = localStorage.getItem('userInfo');
    
    if (token && userInfo) {
      // 用户已登录，跳转到首页
      this.$router.replace('/');
      return;
    }
    // if (this.payInfo.paypalStatus && this.payInfo.stripeStatus && this.payInfo.wechatPaySwitch) {
    //   this.payStatus = 0
    //   this.payType = 'stripe'
    // } else if (!this.payInfo.paypalStatus && this.payInfo.stripeStatus) {
    //   this.payStatus = this.payInfo.paypalStatus ? 1 : 0
    //   this.payType = this.payInfo.paypalStatus ? 'paypal' : 'stripe'
    // } else if (!this.payInfo.paypalStatus && !this.payInfo.stripeStatus && this.payInfo.wechatPaySwitch) {
    //   this.payStatus = 2
    //   this.payType = 'wechat'
    // } else {
    //   this.payStatus = 0
    //   this.payType = ''
    // }
    const card_ids = this.$route.query.cartId
    console.log(card_ids)
    this.cartId = card_ids
    // 获取订单信息
    this.getOrderInfo();
  },

  head() {
    return {
      title: this.$t(`page.users.orderConfirm.navTitle`)
    }
  },
  watch: {
    delivery(val) {
      // 切换配送方式时重新计算运费
      this.calculateDeliveryFee();
    },
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.consigneeTimer) {
      clearInterval(this.consigneeTimer);
      this.consigneeTimer = null;
    }
  },
  methods: {
    currentPay(index) {
      this.payStatus = index;
      this.payType = index === 0 ? 'stripe' : index === 1 ? 'paypal' : index === 2 ? 'mercado' : index === 3 ? 'offline' : '';
    },
    /**
     * 获取订单信息
     */
    getOrderInfo() {
      const params = {
        language: Cookies.get('locale')
      };
      
      // 判断是从商品详情还是购物车进来
      if (this.$route.query.goodId && this.$route.query.num) {
        // 从商品详情直接下单
        params.id = this.$route.query.goodId;
        params.num = this.$route.query.num;
        params.sub_id = this.$route.query.sub_id;
      } else if (this.cartId) {
        // 从购物车进来
        params.card_ids = this.cartId;
      }
      
      this.$axios.post('/api/order/getPayInfo', params).then(res => {
        console.log(res, 'orderData');
        let orderInfoVo = res.data.orderInfoVo || res.data;
        
        // 设置订单信息
        this.orderInfoVo = {
          totalPrice: orderInfoVo.totalPrice || 0, // 商品总价
          shippingFree: 0, // 运费
          payFee: orderInfoVo.payFee || 0, // 实付款
          couponFee: 0 // 优惠券抵扣
        };
        
        // 设置优惠券列表
        this.couponList = res.data.usableCouponList || [];
        
        // 设置门店列表
        this.storeList = orderInfoVo.tiAddress || [];
        // 保存免运费门槛
        this.mianfree = orderInfoVo.mianfree || 0;
        
        // 计算商品总重量
        if (orderInfoVo.goodList && orderInfoVo.goodList.length > 0) {
          this.weight = orderInfoVo.goodList.reduce((total, item) => {
            return total + (parseFloat(item.weight || 0) * parseInt(item.num || 1));
          }, 0);
          
          // 将商品列表包装成订单格式
          this.cartInfo = [{
            orderInfoList: orderInfoVo.goodList,
            merName: '商品信息'
          }];
        }
        
        // 计算最终金额
        this.calculateFinalAmount();
      }).catch(err => {
        this.$message.error(err.message || '加载订单信息失败');
      });
    },
    tapCurrent(index, item) {
      this.current = index;
      this.checkedStore = item;
    },
    
    /**
     * 发送验证码
     */
    sendVerificationCode() {
      // 验证邮箱格式
      if (!this.addressForm.email) {
        this.$message.error(this.$t('page.orderDetails.tipEmailFirst'));
        return;
      }
      
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailReg.test(this.addressForm.email)) {
        this.$message.error(this.$t('page.orderDetails.tipEmailInvalid'));
        return;
      }
      
      // 发送验证码请求
      this.$axios.post('/api/index/sendMail', {
        email: this.addressForm.email,
        type: '1'
      }).then(res => {
        this.$message.success(this.$t('page.orderDetails.tipCodeSent'));
        
        // 开始倒计时
        this.countdown = 60;
        this.timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }).catch(err => {
        this.$message.error(err.message || this.$t('page.orderDetails.tipCodeFailed'));
      });
    },
    
    /**
     * 发送收货人验证码
     */
    sendConsigneeVerificationCode() {
      // 验证邮箱格式
      if (!this.consigneeInfo.email) {
        this.$message.error(this.$t('page.orderDetails.tipEmailFirst'));
        return;
      }
      
      const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailReg.test(this.consigneeInfo.email)) {
        this.$message.error(this.$t('page.orderDetails.tipEmailInvalid'));
        return;
      }
      
      // 发送验证码请求
      this.$axios.post('/api/index/sendMail', {
        email: this.consigneeInfo.email,
        type: '1'
      }).then(res => {
        this.$message.success(this.$t('page.orderDetails.tipCodeSent'));
        
        // 开始倒计时
        this.consigneeCountdown = 60;
        this.consigneeTimer = setInterval(() => {
          this.consigneeCountdown--;
          if (this.consigneeCountdown <= 0) {
            clearInterval(this.consigneeTimer);
            this.consigneeTimer = null;
          }
        }, 1000);
      }).catch(err => {
        this.$message.error(err.message || this.$t('page.orderDetails.tipCodeFailed'));
      });
    },
    
    /**
     * 懒加载地区数据
     */
    lazyLoadRegion(node, resolve) {
      const { level, value } = node;
      
      // 根据层级请求不同的数据
      // level 0: 省级, level 1: 市级, level 2: 区级
      const parentId = level === 0 ? 0 : value;
      
      this.$axios.post('/api/index/getRegionList', {
        id: parentId,
        level: level + 1
      }).then(res => {
        const nodes = res.data.map(item => ({
          id: item.id,
          name: item.name,
          leaf: level >= 2 // 第三级（区）没有子节点
        }));
        resolve(nodes);
      }).catch(err => {
        console.error('Failed to load region data:', err);
        resolve([]);
      });
    },
    
    /**
     * 地区选择变化
     */
    handleRegionChange(value) {
      console.log('Selected region:', value);
      // value 是一个数组 [省id, 市id, 区id]
      if (value && value.length > 0) {
        // 使用 cascader 的 getCheckedNodes 方法获取选中节点
        this.$nextTick(() => {
          const checkedNodes = this.$refs.regionCascader.getCheckedNodes();
          if (checkedNodes && checkedNodes.length > 0) {
            // 获取完整路径的标签
            const labels = checkedNodes[0].pathLabels;
            this.addressForm.country = labels.join(' ');
            console.log('Selected labels:', labels);
            console.log(value.length, this.delivery, this.weight)
            // 如果是快递模式且选择了完整的三级地区,获取运费
            if (value.length == 3 && this.delivery == '2' && this.weight > 0) {
              
              this.getDeliveryFee();
            }
          }
        });
      } else {
        // 清空选择
        this.addressForm.country = '';
      }
    },

    /**
     * 获取门店列表
     */
    // getStoreList() {
    //   this.$axios.get('/api/store/list').then(res => {
    //     this.storeList = res.data || [];
    //   }).catch(err => {
    //     console.error('Failed to load store list:', err);
    //   });
    // },

    /**
     * 获取运费
     */
    getDeliveryFee() {
      
      if (!this.selectedRegion || this.selectedRegion.length < 3 || !this.weight) {
        return;
      }
      
      // 判断商品价格是否超过免运费门槛
      const productTotal = parseFloat(this.orderInfoVo.totalPrice || 0);
      console.log(this.mianfree, productTotal)
      if (this.mianfree > 0 && productTotal >= this.mianfree) {
        // 商品价格超过免运费门槛,免运费
        this.orderInfoVo.shippingFree = 0;
        this.calculateFinalAmount();
        return;
      }
      
      // 未达到免运费门槛,调用接口计算运费
      const regions_id3 = this.selectedRegion[2]; // 获取区县级ID
      this.$axios.get(`/api/order/getShippingFree`, {
        params: {
          regions_id: regions_id3,
          weight: this.weight
        }
      }).then(res => {
        this.orderInfoVo.shippingFree = res.data;
        this.calculateFinalAmount();
      }).catch(err => {
        console.error('获取运费失败:', err);
      })
    },

    /**
     * 计算运费
     */
    calculateDeliveryFee() {
      if (this.delivery === '1') {
        // 到店自提免运费
        this.orderInfoVo.shippingFree = 0;
      } else {
        // 快递配送,如果已选择地区则获取运费
        if (this.selectedRegion && this.selectedRegion.length === 3 && this.weight > 0) {
          this.getDeliveryFee();
          return;
        }
      }
      this.calculateFinalAmount();
    },

    /**
     * 计算最终金额
     */
    calculateFinalAmount() {
      this.$set(this.orderInfoVo, 'payFee', (
        parseFloat(this.orderInfoVo.totalPrice || 0) + 
        parseFloat(this.orderInfoVo.shippingFree || 0)
      ).toFixed(2));
    },

    getCoupon(coupon, index) {
      this.couponIndex = index;
      this.$set(coupon, 'checked', !coupon.checked);
      if (coupon.checked) {
        this.couponId = coupon.id
      } else {
        this.couponId = ''
      }
      // 重新计算价格
      this.calculateFinalAmount();
    },
    
    //提交订单
    SubOrder: Debounce(async function (event) {
            let that = this;

      if (this.payType === 'mercado' && parseFloat(this.orderInfoVo.payFee) <= 3) {
        this.$message.error(this.$t('message.orderConfirm.mercadoMinAmountTip'));
        if(event && event.target) {
          event.target.disabled = false;
        }
        return;
      }

      
      // 快递配送需要验证地址表单
      if (this.delivery === '2') {
        const valid = await this.$refs.addressForm.validate().catch(() => false);
        if (!valid) {
          this.$message.error(this.$t('page.orderDetails.tipFormIncomplete'));
          return false;
        }
        
        // 检查是否选择了地区
        if (!this.selectedRegion || this.selectedRegion.length === 0) {
          this.$message.error(this.$t('page.orderDetails.tipSelectRegion'));
          return false;
        }
      }

      // 如果是到店自提，验证收货人表单并检查是否选择了门店
      if (this.delivery === '1') {
        const valid = await this.$refs.consigneeForm.validate().catch(() => false);
        if (!valid) {
          this.$message.error(this.$t('page.orderDetails.tipFormIncomplete'));
          return false;
        }
        
        if (!this.checkedStore.id) {
          this.$message.error('请选择自提门店');
          return false;
        }
      }
      
      // 构建订单数据
      const orderData = {
        delivery: this.delivery, // 1自提 2快递
        payment: this.payStatus, // 支付方式
        remark: this.mark, // 备注
        // coupon_id: this.couponId || '', // 优惠券ID
        // language: Cookies.get('locale')
      };
      
      // 判断是从商品详情还是购物车进来
      if (this.$route.query.goodId && this.$route.query.num) {
        // 从商品详情直接下单
        orderData.good_id = this.$route.query.goodId;
        orderData.num = this.$route.query.num;
        orderData.sub_id = this.$route.query.sub_id;
      } else if (this.cartId) {
        // 从购物车进来
        orderData.cart_ids = this.cartId;
      }
      
      // 如果是快递配送，添加地址信息
      if (this.delivery === '2') {
        orderData.regions_id1 = this.selectedRegion[0] || '';
        orderData.regions_id2 = this.selectedRegion[1] || '';
        orderData.regions_id3 = this.selectedRegion[2] || '';
        orderData.regions = this.addressForm.country;
        orderData.address = this.addressForm.address;
        orderData.email = this.addressForm.email;
        orderData.phone = this.addressForm.phone;
        orderData.name = this.addressForm.name;
        orderData.code = this.addressForm.postCode;
        // orderData.email_code = this.addressForm.verificationCode;
        orderData.is_reg = this.createAccount ? 1 : 0;
      } else {
        // 如果是自提，传门店ID和收货人信息
        orderData.address_id = this.checkedStore.id;
        orderData.name = this.consigneeInfo.name;
        orderData.email = this.consigneeInfo.email;
        orderData.phone = this.consigneeInfo.phone;
        // orderData.email_code = this.consigneeInfo.verificationCode;
        orderData.is_reg = this.consigneeCreateAccount ? 1 : 0;
      }
      
      MessageBox.confirm(this.$t('page.users.orderConfirm.message'), this.$t('page.users.orderConfirm.messageTitle'), {
        confirmButtonText: this.$t('message.common.confirm'),
        cancelButtonText: this.$t('message.common.cancel')
      }).then(async () => {
        try {
          that.loading = true;
          let btn = event.target;
          btn.disabled = true;
          
          // 调用创建订单接口
          const res = await that.$axios.post('/api/order/getCreateOrder', orderData);
          
          that.orderNo = res.data.orderid;
          // 调用支付接口，保持loading状态
          if (that.payType === 'paypal') {
            that.getOrderPay(that.orderNo, btn);
          } else if (that.payType === 'mercado') {
            that.mercadoPay(this.orderNo, btn);
          } else if (that.payType === 'offline') {
            that.offlinePay(this.orderNo, btn);
          }
          that.loading = false;
        } catch (err) {
          that.$message.error(err.msg);
          if (event.target) {
            event.target.disabled = false;
          }
          that.loading = false;
        }
      }).catch(() => {
        // 用户取消
      });
    }),
    
    //支付订单
    getOrderPay(orderNo, btn) {
      this.$axios.post('/api/pay/pay', {
        orderid: orderNo,
      }).then(res => {
        window.location.href = res.data;
        // window.open(res.data, '_blank');
        // 支付请求成功，关闭loading
        this.loading = false;
      }).catch(err => {
        // 支付失败，关闭loading并提示错误
        this.loading = false;
        this.$message.error(err.message || '支付请求失败,请稍后重试');
      }).finally(() => {
        btn.disabled = false
      })
    },
    // 线下支付
    offlinePay(orderNo) {
      this.loading = false;
      this.offlinePayDialogVisible = true;
    },
    handleOfflinePayConfirm() {
      this.$router.push({ path: '/' });
    },
    // mercado支付
    mercadoPay(orderNo, btn) {
       this.$axios.post('/api/paytwo/create', {
        orderid: orderNo,
      }).then(res => {
        // 支付请求成功，关闭按钮loading
        this.loading = false;
        // 打开支付页面
        window.location.href = res.data;
        // window.open(res.data, '_blank');
      }).catch(err => {
        // 关闭全屏loading
        if (loadingInstance) {
          loadingInstance.close();
        }
        // 支付失败，关闭按钮loading并提示错误
        this.loading = false;
        this.$message.error(err.message || '支付请求失败,请稍后重试');
      }).finally(() => {
        btn.disabled = false
      })
    },
    //预览二维码
    getQRcode(redirect) {
      document.getElementById('payQrcode').innerHTML = '';
      new QRcode('payQrcode', { width: 135, height: 135, text: redirect });
      this.loadingQrcode = false;
    },
    
    //获取微信支付结果
    getPaymentStatus() {
      this.loadingQrcode = true;
      this.$axios.get(`/api/front/pay/query/wechat/pay/result/${this.orderNo}`).then(res => {
        this.handleCloseQrcode();
        this.loadingQrcode = false;
        this.$router.push({ path: '/users/order_list?orderStatus=0' });
      }).catch(err => {
        this.handleCloseQrcode();
        this.loadingQrcode = false;
        this.$router.push({ path: '/users/order_list?orderStatus=0' });
      })
    },
    
    //关闭微信支付弹窗
    handleCloseQrcode() {
      this.dialogVisibleQrcode = false;
      this.$router.push({ path: '/users/order_list?orderStatus=0' });
    }
  }
}
</script>

<style scoped lang="scss">
.payQrcode {
  margin: auto;
  width: 135px;
  height: 135px;
}

.mr20 {
  margin-right: 20px;
}

.payType {
  width: 100%;
  background-color: #fff;
  padding: 0 30px;

  .title {
    height: 68px !important;
    line-height: 68px !important;
    font-size: 14px !important;
    color: #282828 !important;
    padding: 0 !important;
  }

  .type {
    .item {
      width: 210px;
      height: 70px;
      border: 1px solid #D4D4D4;
      position: relative;
      cursor: pointer;
      margin-right: 20px;

      &~.item {
        margin-right: 20px;
      }

      &.on {
        border-color: #E93323;
      }

      .iconfont {
        color: #09BB07;
        font-size: 29px;
        margin-right: 11px;
        width: 30px;
        height: 30px;

        .img {
          width: 100%;
          height: 100%;
        }

        &.icon-yue {
          font-size: 32px;
          color: #FE9C01;
        }

        &.icon-zhifubao {
          font-size: 36px;
          color: #00AAEA;
        }
      }

      .icon-xuanzhong4 {
        position: absolute;
        right: -4px;
        bottom: -4px;
        margin: 0 !important;
      }

      .name {
        font-size: 16px;
        color: #4E4E4E;
      }

      .yue {
        font-size: 14px;
        color: #969696;
        margin-top: 6px;
      }
    }
  }

  .goPay {
    margin: 80px 50px 0 0;

    .bnt,
    .button {
      width: 180px;
      height: 46px;
      font-size: 16px;
      color: #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 46px;
      cursor: pointer;
    }

    .button {
      outline: none;
      border: none;
      background-color: #E93323;

      &:disabled {
        border-color: #fab6b6;
        background-color: #fab6b6;
      }
    }
  }
}

.line {
  border-bottom: 1px solid #EFEFEF;
}

.couponListBox {
  padding: 30px 30px 0 30px;
}

.order_confirm {
  .header {
    height: 60px;
    line-height: 60px;
    color: #999999;

    .home {
      color: #282828;
    }
  }

  .address {
    background-color: #fff;

    .title {
      height: 64px;
      font-size: 18px;
      padding: 0 28px;
      line-height: 64px;
    }

    .lines {
      width: 100%;
      height: 4px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    // 地址表单
    .address-form {
      padding: 30px;
    }

    // 配送方式
    .delivery {
      padding: 0 28px 30px;
      
      .title {
        height: 64px;
        font-size: 18px;
        line-height: 64px;
        padding: 0;
      }
      
      .store-selection {
        .store-option {
          .store-name {
            font-size: 14px;
            color: #333;
            font-weight: bold;
          }

          .store-address {
            font-size: 12px;
            color: #999;
            margin-top: 5px;
          }
        }
      }
    }
  }

  .couponList {
    .item {
      height: 40px;
      border: 1px solid #E93323;
      margin: 0 20px 30px 0;
      position: relative;
      cursor: pointer;

      &.disabled {
        pointer-events: none;
        opacity: .6;
      }

      &.grey {
        border-color: #B4B4B4;
      }

      .iconfont {
        position: absolute;
        right: -3px;
        bottom: -2px;
        font-size: 20px;
      }

      .name {
        width: 70px;
        height: 100%;
        color: #fff;
        text-align: center;
        line-height: 40px;
        background-color: #E93323;

        &.grey {
          background-color: #B4B4B4;
        }
      }

      .money {
        width: 110px;
        text-align: center;
        color: #E93323;

        &.grey {
          color: #B4B4B4;
        }
      }

      &.svip {
        border-color: #333;

        .name {
          background-color: #333;
          color: #FDD7B4;
        }

        .money {
          color: #333;
        }
      }
    }
  }

  .coupon {
    .msgTitle {
      font-size: 14px;
      color: #282828;
    }
  }

  .message {
    padding: 30px;

    .textarea {
      width: 820px;
      height: 120px;
      background-color: #F7F7F7;
      border: 0;
      outline: none;
      resize: none;
      padding: 12px 14px;
      margin-left: 26px;
    }
  }

  .wrapper {
    .wrapper_count {
      background-color: #fff;
      padding-bottom: 56px;

      &:last-child {
        margin-top: 14px;
      }
    }

    .integral_count {
      padding: 0 0 24px 0;
      position: relative;

      .integral_title {
        font-size: 14px;
        color: #282828;
      }

      .money {
        margin-top: 15px;
        align-items: center;
      }

      .integral_price {
        position: absolute;
        right: 32px;
      }
    }

    .title {
      height: 64px;
      line-height: 64px;
      padding: 0 28px;
      font-size: 18px;
    }

    .totalCon {
      padding: 27px 46px;

      .total {
        &~.total {
          margin-top: 12px;
        }

        .money {
          width: 120px;
          text-align: right;
          font-size: 16px;
        }
      }
    }

    .totalAmount {
      width: 1160px;
      height: 70px;
      line-height: 70px;
      background: #F7F7F7;
      text-align: right;
      padding-right: 22px;
      margin: 0 auto;

      .money {
        font-size: 20px;
        font-weight: bold;
        margin-left: 4px;
        width: 120px;
        display: inline-block;
      }
    }

    .bnt {
      margin: 38px 20px 0 0;
      cursor: pointer;

      .submit {
        width: 180px;
        height: 46px;
        border-radius: 4px;
        font-size: 16px;
        color: #fff;
        text-align: center;
        line-height: 46px;
        outline: none;
        border: none;
        background-color: #E93323;

        &:disabled {
          border-color: #fab6b6;
          background-color: #fab6b6;
        }
      }
    }
  }
}

.consigneeInfo {
  background-color: #fff;
  margin-top: 14px;
  padding: 20px 28px;

  .title {
    height: 64px;
    font-size: 18px;
    line-height: 64px;
  }

  .info-content {
    padding: 20px 0;

    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      .label {
        width: 100px;
        font-size: 14px;
        color: #999;
      }

      .value {
        flex: 1;
        font-size: 14px;
        color: #333;
      }

      .edit-btn {
        color: #E93323;
        font-size: 14px;
        cursor: pointer;
        margin-left: 20px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.store-list {
  padding: 0 25px 26px 25px;
  height: 217px;
  overflow: hidden;

  &.on {
    height: auto;
  }

  .item {
    width: 250px;
    height: 170px;
    border: 1px solid #EAEAEA;
    padding: 22px 27px;
    overflow: hidden;
    margin: 30px 0 0 30px;
    position: relative;
    cursor: pointer;

    &.on {
      border: 1px solid #E93323;
    }

    .icon-xuanzhong4 {
      position: absolute;
      right: -4px;
      bottom: -4px;
      font-size: 27px;
    }

    .default {
      position: absolute;
      width: 56px;
      height: 23px;
      font-size: 12px;
      color: #fff;
      text-align: center;
      line-height: 23px;
      top: 0;
      right: 0;
    }

    &.add {
      text-align: center;

      .iconfont {
        font-size: 35px;
        color: #BFBFBF;
        margin-top: 25px;
      }

      .tip {
        color: #C8C8C8;
        margin-top: 8px;
      }
    }

    .name {
      font-size: 16px;
    }

    .phone {
      margin-top: 9px;
    }

    .details {
      color: #999;
      margin-top: 4px;
    }
  }
}
</style>

